/**
 * NCAA Basketball Sport Configuration (Stub)
 *
 * Basic structure for NCAA Basketball support. Expand with conference/team data
 * when NCAA launches.
 */

import type { SportConfig } from './types';

export const ncaaConfig: SportConfig = {
  sport: 'NCAA_BASKETBALL',
  label: 'NCAA Basketball',
  shortLabel: 'NCAA',

  oddsApiSportKey: 'basketball_ncaab',

  drawLabel: 'Tie',
  espnPath: { sport: 'basketball', league: 'mens-college-basketball' },

  positions: [
    { id: 'PG', label: 'Point Guard', abbreviation: 'PG' },
    { id: 'SG', label: 'Shooting Guard', abbreviation: 'SG' },
    { id: 'SF', label: 'Small Forward', abbreviation: 'SF' },
    { id: 'PF', label: 'Power Forward', abbreviation: 'PF' },
    { id: 'C', label: 'Center', abbreviation: 'C' },
  ],

  propCategories: [
    { id: 'POINTS', label: 'Goals', oddsApiMarket: 'player_points' },
    { id: 'REBOUNDS', label: 'Rebounds', oddsApiMarket: 'player_rebounds' },
    { id: 'ASSISTS', label: 'Assists', oddsApiMarket: 'player_assists' },
    { id: 'THREE_POINTERS_MADE', label: '3-Pointers Made', oddsApiMarket: 'player_threes' },
  ],

  defaultRosterSlots: [
    { slot: 'PG', eligiblePositions: ['PG'], label: 'Point Guard' },
    { slot: 'SG', eligiblePositions: ['SG'], label: 'Shooting Guard' },
    { slot: 'SF', eligiblePositions: ['SF'], label: 'Small Forward' },
    { slot: 'PF', eligiblePositions: ['PF'], label: 'Power Forward' },
    { slot: 'C', eligiblePositions: ['C'], label: 'Center' },
    { slot: 'UTIL', eligiblePositions: ['PG', 'SG', 'SF', 'PF', 'C'], label: 'Utility' },
  ],

  defaultRosterSize: 6,
  defaultMaxProps: 4,

  identity: {
    color: '#3F51B5',
    metal: 'Indigo',
    icon: 'GraduationCap',
  },

  teams: {},
};
